import { apiEndpoint } from '../../config/app'
import createRestApiClient from '../utils/createRestApiClient'

export default () => {
  const client = createRestApiClient().withConfig({ baseURL: apiEndpoint })
  return {
    login: ({ email, password }) => client.request({
      method: 'POST',
      url: '/sessions',
      data: {
        email,
      password}
    }),
    signUp: ({ email, password }) => client.request({
      method: 'POST',
      url: '/users',
      data: {
        email,
      password}
    }),
    logOut: () => client.request({
      method: 'DELETE',
      url: '/sessions'
    }),
    getAccount: () => client.request({
      method: 'GET',
      url: `/account`
    }),
    updateAccount: (account) => client.request({
      method: 'POST',
      url: `/account`,
      data: account
    }),
    deleteAccount: ()=> client.request({
      method: 'DELETE',
      url: '/account'
    }),
    revertSystem: (date) => client.request({
      method: 'POST',
      url: '/account/revert',
      data: date
    }),
    testGoogleDrive: () => client.request({
      method: 'POST',
      url: '/account/test/google-drive'
    }),
    testFtp: (data) => client.request({
      method: 'POST',
      url: '/account/test/ftp',
      data
    }),
    testSmtp: (data) => client.request({
      method: 'POST',
      url: '/account/test/smtp',
      data
    })
  }
}



// WEBPACK FOOTER //
// app/services/authentication.js